import type { AnalyticsObject, AnalyticsProperties } from '@core/analytics/types'

export type TilesDisplayed = Record<string, string[]> | undefined
export interface TileProperties extends AnalyticsProperties {
  section: string
  tileId: string
  tileTitle: string
  tileUrl: string
  tilesDisplayed: TilesDisplayed
}

export class Tile implements AnalyticsObject {
  name: string
  properties: TileProperties
  constructor(properties: TileProperties) {
    this.name = 'Tile'
    this.properties = properties
  }
}
